module.exports = __webpack_public_path__ + "static/media/facebook-footer.517134f9.svg";